import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getChipSize, interactiveStateProps, getTextColor } from './shared.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isDisabled = function isDisabled(state) {
  return state === 'disabled';
};
var isSelected = function isSelected(selection) {
  return selection === 'selected';
};
var getBorderRadius = function getBorderRadius(isTwoLine) {
  return isTwoLine ? '8' : 'base';
};
var getBorderColor = function getBorderColor(selection, state) {
  if (isDisabled(state)) return 'base.subtle';
  return isSelected(selection) ? 'product.primary.strong' : 'base.default';
};
var getBorderWidth = function getBorderWidth(selection, state, dismissible) {
  if (isDisabled(state)) return '1';
  if (isSelected(selection)) return dismissible ? '1' : '2';
  return '1';
};
var getBackgroundColor = function getBackgroundColor(selection, state, dismissible) {
  if (isDisabled(state)) return 'base.surface';
  if (isSelected(selection)) return dismissible ? 'base.surface' : 'product.primary.subtle';
  return 'base.surface';
};
var getHeight = function getHeight(size, isTwoLine) {
  if (isTwoLine) return '44px';
  return getChipSize(size) === 's' ? '28px' : '36px';
};
var resolveWidth = function resolveWidth(width) {
  if (width === 'parent-fit') {
    return '100%';
  }
  return width;
};
var getPaddingHorizontal = function getPaddingHorizontal(size, isTwoLine) {
  if (isTwoLine) return '16';
  return getChipSize(size) === 's' ? '12' : '16';
};
var getIsTwoline = function getIsTwoline(props) {
  return props.flexDirection === 'column';
};
var isDismissIconDisplay = function isDismissIconDisplay(selection, dismissible, isTwoLine) {
  return selection === 'selected' && dismissible === true && isTwoLine !== true;
};
var getDismissIconSize = function getDismissIconSize(size) {
  return getChipSize(size) === 's' ? '12' : '14';
};
var mapReservedSpaceForDismissIcon = function mapReservedSpaceForDismissIcon(theme, props) {
  var selection = props.selection,
    dismissible = props.dismissible,
    size = props.size;
  if (!isDismissIconDisplay(selection, dismissible, getIsTwoline(props))) return undefined;
  var iconWidth = theme.icons[getDismissIconSize(size)];
  return {
    width: iconWidth,
    ms: '8'
  };
};
var mapInteractiveDismissIcon = function mapInteractiveDismissIcon(theme, props) {
  var size = props.size;
  var interactiveDismissIconPadding = theme.spacing[4];
  return {
    top: "calc((".concat(getHeight(size), " - (").concat(theme.icons[getDismissIconSize(size)], " + ").concat(interactiveDismissIconPadding, "*2))/2)"),
    end: "calc(".concat(theme.spacing[getPaddingHorizontal(size)], " - ").concat(interactiveDismissIconPadding, ")")
  };
};
var mapDismissIconBox = function mapDismissIconBox(props) {
  var selection = props.selection,
    dismissible = props.dismissible;
  if (!isDismissIconDisplay(selection, dismissible, getIsTwoline(props))) return undefined;
  return _objectSpread({
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    p: '4'
  }, interactiveStateProps(props));
};
var mapDismissIcon = function mapDismissIcon(props, exp) {
  var selection = props.selection,
    state = props.state,
    size = props.size;
  return {
    id: 'fill.symbol.close',
    color: getTextColor(selection, state, exp),
    size: getDismissIconSize(size)
  };
};
var mapBoxProps = function mapBoxProps(props, exp) {
  var selection = props.selection,
    dismissible = props.dismissible,
    state = props.state,
    width = props.width,
    minWidth = props.minWidth,
    size = props.size,
    flexDirection = props.flexDirection;
  var isTwoLine = getIsTwoline(props);
  return _objectSpread(_objectSpread({
    display: 'flex',
    flexDirection: flexDirection !== null && flexDirection !== void 0 ? flexDirection : 'row',
    justifyContent: 'center',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    px: getPaddingHorizontal(size, isTwoLine),
    py: '4'
  }, interactiveStateProps(props)), {}, {
    backgroundColor: getBackgroundColor(selection, state, dismissible),
    borderStyle: 'solid',
    borderColor: getBorderColor(selection, state),
    borderWidth: getBorderWidth(selection, state, dismissible),
    borderRadius: getBorderRadius(isTwoLine),
    textColor: getTextColor(selection, state, exp),
    width: resolveWidth(width),
    minWidth: resolveWidth(minWidth),
    minHeight: getHeight(size, isTwoLine),
    type: 'button'
  });
};

export { getDismissIconSize, isDisabled, isSelected, mapBoxProps, mapDismissIcon, mapDismissIconBox, mapInteractiveDismissIcon, mapReservedSpaceForDismissIcon };
//# sourceMappingURL=BaseChip.mappers.js.map
